import { grid } from '../../script'

(function( $ ) {

	if ( ! document.querySelector('.page-template-search-results') ) {
		return
	}

	/**
	 * Transform tabs to dropdown
	 * @param  {object} tabArea  Tab Area element.
	 * @return {null}
	 */
	let transformTabsToDropdown = ( tabArea ) => {

		// Build container elem.
		let container = document.createElement('div')
		container.setAttribute( 'id', 'search-tab-dropdown' )

		// Create title.
		let title = document.createElement('button')
		let titleText = document.createTextNode('All')
		title.appendChild( titleText )

		let icon = document.createElement('i')
		icon.setAttribute( 'class', 'icon-chev-down' )

		title.appendChild( icon )

		let items = document.createElement('div')
		items.setAttribute( 'class', 'items' )

		// Add title and empty items to the container.
		container.appendChild( title )
		container.appendChild( items )

		let dropdown = container.children[1];

		// Add tabs to the dropdown items.
		$( tabArea ).find('.gsc-tabHeader').each((i, item) => {
			dropdown.appendChild( item )
		})
		
		// Insert it into the page.
		document.querySelector('.gsc-results-wrapper-nooverlay').insertBefore( container, tabArea )

		document.querySelector('#search-tab-dropdown button').addEventListener( 'click', ( e ) => {
			$( container ).find('.items').slideToggle(200)
		})
	}

	let setAriaTags = () => {
		$( '.gsc-tabHeader' ).attr( 'aria-expanded', 'false' )
		$( '.gsc-tabhActive' ).attr( 'aria-expanded', 'true' )
	}

	$( document ).on( 'click', '.gsc-tabHeader', ( e ) => {

		setAriaTags()

		if ( ! window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {
			$('#search-tab-dropdown .items').slideToggle(200)
			let text = $( e.currentTarget ).text()
			$('#search-tab-dropdown button').html( text + '<i class="icon-chev-down"></i>' )
		}
	})

	// Decect when Google's tabs are loaded before firing transformTabsToDropdown.
	let observer = new MutationObserver( ( mutations, me ) => {
		let tabArea = document.querySelector('.gsc-tabsArea')
		if ( tabArea ) {
			transformTabsToDropdown( tabArea )
			setAriaTags( null )
			me.disconnect()
			return
		}
	})

	observer.observe( document, {
		childList: true,
		subtree: true
	})

})( jQuery );


// WEBPACK FOOTER //
// ./assets/js/components/template/search.js